var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7647 24.969C23.9537 24.969 24.1401 25.0378 24.282 25.1689C25.1888 26.0064 26.5116 26.2853 27.6875 25.9363C26.9307 24.4282 26.8258 22.7005 27.4123 21.1008C28.1401 19.1105 28.3225 17.1157 27.4942 15.1149C26.7665 13.3573 25.3622 11.8971 23.585 11.0644C23.6943 11.622 23.7494 12.1901 23.7494 12.7642C23.7495 15.201 22.7698 17.493 20.9911 19.2178C19.2121 20.9429 16.8275 21.9129 14.2765 21.9492C13.8026 21.9563 13.3307 21.9296 12.8643 21.8708C14.2662 24.2215 16.9104 25.7524 19.8159 25.7936C21.087 25.8124 22.3074 25.5577 23.444 25.0385C23.5463 24.9917 23.6559 24.969 23.7647 24.969Z",
    fill: "url(#paint0_linear_3872_1229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2982 5.00155C9.7728 4.9156 6.01094 8.41743 6.00002 12.7452C5.99735 13.8025 6.21313 14.8277 6.64141 15.7923C6.64763 15.8063 6.65342 15.8205 6.65866 15.8349C7.24511 17.4346 7.1403 19.1623 6.38346 20.6704C7.55947 21.0193 8.88208 20.7405 9.78895 19.9029C10.0124 19.6964 10.3467 19.6445 10.627 19.7726C11.7634 20.2918 12.984 20.5473 14.255 20.5278C18.745 20.464 22.2621 17.0539 22.262 12.7643C22.2621 8.5683 18.6895 5.08599 14.2982 5.00155ZM9.79386 13.9239C9.14369 13.9239 8.6166 13.4205 8.6166 12.7997C8.6166 12.1788 9.14369 11.6755 9.79386 11.6755C10.444 11.6755 10.9711 12.1788 10.9711 12.7997C10.9711 13.4205 10.444 13.9239 9.79386 13.9239ZM14.1311 13.9239C13.4809 13.9239 12.9538 13.4205 12.9538 12.7997C12.9538 12.1788 13.4809 11.6755 14.1311 11.6755C14.7812 11.6755 15.3083 12.1788 15.3083 12.7997C15.3083 13.4205 14.7812 13.9239 14.1311 13.9239ZM18.4683 13.9239C17.8181 13.9239 17.291 13.4205 17.291 12.7997C17.291 12.1788 17.8181 11.6755 18.4683 11.6755C19.1185 11.6755 19.6456 12.1788 19.6456 12.7997C19.6456 13.4205 19.1185 13.9239 18.4683 13.9239Z",
    fill: "url(#paint1_linear_3872_1229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1229",
    x1: 20.4526,
    y1: 11.0644,
    x2: 20.4526,
    y2: 26.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3872_1229",
    x1: 14.131,
    y1: 5,
    x2: 14.131,
    y2: 20.8173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/Chat-icon.4a933ca51465bdc9c6a0cb40e2aeb49c.svg";
export { ForwardRef as ReactComponent };